<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view')}} {{ $tc('role', 1) }} {{ $t('access') }}</div>
      <div>
        <router-link class="btn-blue" to="edit-role-access">{{ $t('edit') }}</router-link>
        <router-link
          class="btn-blue"
          to="role-access"
        >{{ $tc('role', 1) }} {{ $t('access') }} {{ $tc('list', 2) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('select') }} {{ $tc('role', 1) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{selectedRole.label}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('select') }} {{ $tc('module', 1) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{selectedModule.label}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('feature', 1) }} 1</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{feature_name}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('feature', 1) }} 2</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('feature', 1) }} 3</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('feature', 1) }} 4</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('status', 1) }}</div>
              <div
                v-if="selectedData.rf_is_active == 'Y'"
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ $t('active') }}</div>
              <div
                v-if="selectedData.rf_is_active == 'N'"
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ $t('inactive') }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdby') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ $tc('ho', 1) }} {{ $t('manager') }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdat') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{selectedData.rf_created_at}}</span>
                <!-- <span>12:05 AM</span> -->
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedby') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ $tc('ho', 1) }} {{ $t('manager') }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedat') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{selectedData.rf_updated_at}}</span>
                <!-- <span>12:05 AM</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import UserPermission from "@/services/UserPermission";

export default {
  data() {
    return {
      selectedData: {},
      feature_name: "",
      role_featuresId: "",
      selectedRole: {
        label: "Select Role",
        value: ""
      },
      Roles: [],
      RolesMethod: {
        GET: "/admin/",
        tableName: "ms_roles",
        urlKey: "roles"
      },
      selectedModule: {
        label: "Select Module",
        value: ""
      },
      Modules: [],
      ModulesMethod: {
        GET: "/admin/",
        tableName: "ms_modules",
        urlKey: "modules"
      },
      Features: [],
      selectedFeatures: [],
      FeaturesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_features",
        urlKey: "features"
      }
    };
  },
  beforeMount() {
    this.getRolesList();
    this.getModulesList();
  },
  mounted() {
    const { role_featuresId } = this.$route.query;
    this.role_featuresId = this.$route.query.role_featuresId;
  },
  methods: {
    onSelectHandler: function(type, value) {
      if (type == "role") {
        this.selectedRole.label = value.role_name;
        this.selectedRole.value = value.role_id;
      } else if (type == "moduleItem") {
        this.selectedModule.label = value.module_name;
        this.selectedModule.value = value.module_id;
        this.getFeaturesList(value.module_id);
      } else if (type == "feature") {
        let index = this.selectedFeatures.indexOf(value.feature_id);
        if (index > -1) {
          this.selectedFeatures.splice(index, 1);
        } else {
          this.selectedFeatures.push(value.feature_id);
        }
      }
    },
    getRolesList: function() {
      this.Roles = [];
      let body = this.getRequestBody("GET", undefined, this.RolesMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Roles = data.Records;
              this.getRoleById(this.role_featuresId);
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getModulesList: function() {
      this.Modules = [];
      let body = this.getRequestBody("GET", undefined, this.ModulesMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Modules = data.Records;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getFeaturesList: function(module_id) {
      this.Features = [];
      let body = this.getRequestBody("GET", undefined, {
        ...this.FeaturesMethod,
        params: { id: "module_id-" + module_id }
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Features = data.Records;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getRoleById: function(role_featuresId) {
      UserPermission.ReadRoleById(role_featuresId)
        .then(result => {
          const { data } = result;
          // console.log("data :", data);
          this.selectedRole.value = data[0].role_id;
          this.selectedModule.value = data[0].module_id;
          this.feature_name = data[0].feature_name;
          this.selectedData = data[0];
          this.selectedFeatures.push(data[0].feature_id);
          this.getFeaturesList(data[0].module_id);

          this.Roles.map(x => {
            if (x.role_id == this.selectedRole.value) {
              this.selectedRole.label = x.role_name;
            }
          });
          this.Modules.map(x => {
            if (x.module_id == this.selectedModule.value) {
              this.selectedModule.label = x.module_name;
            }
          });
        })
        .catch(error => {
          console.log("error :", error);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/RoleManagementContainer/RoleAccessComponents/viewRoleAccess.vue